import { insulationThickness, getPlasterGrainsForButtons } from '@/store/filter/values'

export default {
  image: 'sw8.png',
  pdf: 'sw8.pdf',
  productData: {
    name: 'Aufbau 8: WDVS – Rein geklebte Steinwolle-Lamelle, organisch',
    shorthand: "sw8",
    serialNumber: 'WA-EPS-008',
    
    construction: {
      composition: [
        {
          title: { de: 'Ziel / Wunsch' },
          output: 'Technisch effizient und mit ökologischen Vorteilen',
          type: 'goal',
          value: 'goal-2'
        },
        
        {
          title: { de: 'System' },
          output: 'Lamelle geklebt',
          type: 'system', 
          value: 'system-3'
        },

        {
          title: { de: 'Dämmstoffkleber' },
          output: 'K+A Mörtel Weiss',
          type: 'insulationGlue', 
          value: 'insulationGlue-1'
        },
        {
          title: { de: 'Dämmstoffkleber' },
          output: 'K+A UniMörtel',
          type: 'insulationGlue', 
          value: 'insulationGlue-2'
        },
        {
          title: { de: 'Dämmstoffkleber' },
          output: 'K+A LeichtMörtel',
          type: 'insulationGlue', 
          value: 'insulationGlue-3'
        },

        {
          title: { de: 'Dämmstoff' },
          output: 'ML 041',
          type: 'insulation', 
          value: 'insulation-6'
        },
        ...insulationThickness('insulation-6'),
        {
          title: { de: 'Dübel' },
          output: 'Kein Dübel',
          type: 'dowel',  
          value: null
        },

        {
          title: { de: 'Armierungsmasse' },
          output: 'FlexSpachtel',
          type: 'reinforcingCompound', 
          value: 'reinforcingCompound-3'
        },

        {
          title: { de: 'Armierungsgewebe' },
          output: 'Armierungsgewebe Fein',
          type: 'reinforcingFabric', 
          value: 'reinforcingFabric-1'
        },

        {
          title: { de: 'Putzgrundierung' },
          output: 'PutzGrund',
          type: 'renderPrimer', 
          value: 'renderPrimer-1'
        },

        {
          title: { de: 'Oberputz' },
          output: 'SilikonPutz',
          type: 'finishingPlaster', 
          value: 'finishingPlaster-1'
        },
        ...getPlasterGrainsForButtons('finishingPlaster-1'),
        {
          title: { de: 'Fassadenfarbe' },
          output: 'SÜDWEST SiliconTherm',
          type: 'facadePaint', 
          value: 'facadePaint-1'
        },

        {
          title: { de: 'Fassadenfarbe' },
          output: 'SÜDWEST LotusanTherm',
          type: 'facadePaint', 
          value: 'facadePaint-2'
        },
      ],
      sum: {
        output: '330,5',
        value: 330.5
      }
    }
  }
}
